import { useParams } from "react-router-dom";

export const useChatDeviceContext = () => {
  const { orgId = "", deviceId: routeDeviceId = "" } = useParams();
  const deviceId = routeDeviceId === "all" ? "" : routeDeviceId;

  return {
    orgId,
    routeDeviceId: deviceId,
    deviceId,
  };
};
